import React, { useState } from "react";
import back from "../image/back.png";

const TaxAdit = () => {
  const [openSection, setOpenSection] = useState(null);

  const toggleSection = (section) => {
    setOpenSection(openSection === section ? null : section);
  };

  const handleAppointmentClick = () => {
    window.open(
      "http://topmate.io/sanjay_nathani/?utm_source=topmate&utm_medium=popup&utm_campaign=Page_Ready",
      "_blank"
    );
  };

  return (
    <div className="bg-white rounded-lg">
      {/* Background Section */}
      <div
        className="bg-cover bg-center h-60 flex flex-col justify-center items-center text-center text-white"
        style={{
          backgroundImage: `url(${back})`,
        }}
      >
        <h1 className="text-3xl font-bold text-blue-700">Tax Audit</h1>
        <p className="mt-2 max-w-3xl px-4 text-black font-semibold text-lg sm:text-2xl">
          Get Hassle-Free Tax Audit Services with Sanjay K Nathani & Co.
        </p>
      </div>

      {/* Description Section */}
      <div className="mt-6 mx-4 sm:mx-10 lg:mx-40">
        <p className="text-gray-700 leading-relaxed mb-6">
          Tax audit is an examination or review of accounts of any business or profession carried out by taxpayers from an income tax viewpoint. It makes the process of income computation for filing of return of income easier.
        </p>
        <p className="text-gray-700 leading-relaxed mb-6">
          Sanjay K Nathani & Co. provides comprehensive tax audit services to assist businesses in achieving compliance with the Income Tax Act and mitigating the risk of penalties. Our team of experienced Chartered Accountants possesses extensive knowledge across a range of industries. Our tax audit services include:
        </p>
        <ol className="list-disc list-inside space-y-2 text-gray-700">
          <li>Comprehensive review and analysis of financial statements and records</li>
          <li>Identification of tax liabilities and obligations</li>
          <li>Preparation and submission of tax audit reports as required by the Income Tax Act</li>
          <li>Representation before the Income Tax Department in case of any disputes or inquiries</li>
          <li>Recommendations on tax planning and optimization strategies</li>
        </ol>
      </div>

      {/* FAQ Section */}
      <h2 className="text-xl font-bold text-gray-800 mt-8 mb-4 text-center">When To Conduct Tax Audit Mandatorily</h2>
      <p className="text-gray-700 mb-4 mx-4 sm:mx-10 lg:mx-40">
        The Income Tax Act Of India Mandates A Tax Audit Under Section 44AB For Certain Taxpayers. Here's A Breakdown Of When A Tax Audit Is Compulsory:
      </p>

      {/* Collapsible Sections */}
      <div className="space-y-4 mx-4 sm:mx-10 lg:mx-40">
        {/* Section 1 */}
        <div
          className={`border rounded-lg ${
            openSection === 1 ? "bg-blue-100" : "bg-[#005A8C]"
          }`}
        >
          <button
            onClick={() => toggleSection(1)}
            className="w-full text-left px-4 py-3 text-white font-bold flex justify-between items-center"
          >
            1. For Businesses
            <span>{openSection === 1 ? "-" : "+"}</span>
          </button>
          {openSection === 1 && (
            <div className="px-4 py-3 bg-white text-gray-700">
          <ul className="list-disc list-inside mt-2 space-y-1">
           <li>General Rule: If your business's total sales, turnover, or gross receipts exceed Rs. 1 crore in a financial year, a tax audit is mandatory.</li>
           <li>Higher Threshold for Digital Transactions: If your business has a high proportion of digital transactions (cash transactions do not exceed 5% of total receipts and payments), the threshold limit for a tax audit is increased to Rs. 10 crore. This provision aims to encourage digital transactions.</li>
          <li>Presumptive Taxation Scheme: If you've opted for the presumptive taxation scheme under Section 44AD and your income exceeds the basic exemption limit, you may need a tax audit if you declare profits lower than the prescribed limits.</li>
          <li>Business Loss: If your business incurs a loss and you have not opted for the presumptive taxation scheme, a tax audit is required if your total sales, turnover, or gross receipts exceed Rs. 1 crore.</li>
          </ul>
          </div>
          )}
        </div>

        {/* Section 2 */}
        <div
          className={`border rounded-lg ${
            openSection === 2 ? "bg-blue-100" : "bg-[#005A8C]"
          }`}
        >
          <button
            onClick={() => toggleSection(2)}
            className="w-full text-left px-4 py-3 text-white font-bold flex justify-between items-center"
          >
            2. For Professionals
            <span>{openSection === 2 ? "-" : "+"}</span>
          </button>
          {openSection === 2 && (
            <div className="px-4 py-3 bg-white text-gray-700">
            <ul className="list-disc list-inside mt-2 space-y-1">
              <li>If your gross receipts from your profession exceed Rs. 50 lakh in a financial year, a tax audit is mandatory.</li>
              <li>Higher Threshold for Digital Transactions: If your Profession has a high proportion of digital transactions (cash transactions do not exceed 5% of total receipts and payments), the threshold limit for a tax audit is increased to Rs. 75 Lac. This provision aims to encourage digital transactions</li>
              <li>Similar to businesses, professionals opting for the presumptive taxation scheme under Section 44ADA may require a tax audit under specific conditions related to declared profits and income exceeding the basic exemption limit.</li>
            </ul>
            </div>
          )}
        </div>

        {/* Section 3 */}
        <div
          className={`border rounded-lg ${
            openSection === 3 ? "bg-blue-100" : "bg-[#005A8C]"
          }`}
        >
          <button
            onClick={() => toggleSection(3)}
            className="w-full text-left px-4 py-3 text-white font-bold flex justify-between items-center"
          >
            3. Other Situations
            <span>{openSection === 3 ? "-" : "+"}</span>
          </button>
          {openSection === 3 && (
            <div className="px-4 py-3 bg-white text-gray-700">
              Even if your turnover or receipts are below specified limits, a tax audit might be necessary in certain other situations, such as:
              <ul className="list-disc list-inside mt-2 space-y-1">
                <li>If you are claiming deductions under certain sections of the Income Tax Act.</li>
                <li>If your business is involved in specific activities like foreign transactions or if you have received any foreign contributions.</li>
              </ul>
            </div>
          )}
        </div>
      </div>

      {/* Contact Section */}
      <div className="mt-8 bg-gray-50 p-6 rounded-md shadow-sm mx-4 sm:mx-10 lg:mx-40">
        <h2 className="text-xl font-bold text-gray-800 mb-4">Get in touch</h2>
        <p className="text-gray-600 mb-6">
          If you have any queries or questions, please reach out to us by clicking on the contact button and filling out the form.
        </p>

        {/* Buttons */}
        <div className="flex flex-col sm:flex-row gap-y-4 sm:gap-x-4">
          {/* Make Appointment Button */}
          <button onClick={handleAppointmentClick} className="px-6 py-2 bg-orange-500 text-white rounded hover:bg-orange-600 transition duration-200">
            Make Appointment
          </button>

          {/* Contact Us Button */}
          <button className="px-6 py-2 bg-[#005A8C] text-white rounded hover:bg-blue-600 transition duration-200">
            Contact Us
          </button>
        </div>
      </div>
    </div>
  );
};

export default TaxAdit;
